import { jsx } from 'slate-hyperscript';
import type {
  DeserializePayloadHandlerOptions,
  DeserializePayloadValueHandlerOptions,
  SerializePayloadHandlerOptions,
} from '../../serialize/serialize';
import { SerializePayloadHandler } from '../../serialize/serialize';
import type { MentionMessageProps } from './components/mention-message';
import MentionMessage from './components/mention-message';
import type { MentionElement } from './types';
import { MentionElementType } from './types';
import { getMentionName, isMentionElement } from './utils';

export class SerializePayloadHandler_mention extends SerializePayloadHandler {
  serialize({ entry: [node], context, callback }: SerializePayloadHandlerOptions) {
    if (isMentionElement(node as MentionElement)) {
      const {
        user: { user_id, original_name },
        user,
      } = node as MentionElement;

      if (!context.mentionIds) {
        context.mentionIds = [];
      }

      if (!context.mentionIds.includes(user_id)) {
        context.mentionIds.push(user_id);
      }

      const part = getMentionName(user);

      callback({
        part,
        entity: {
          type: MentionElementType,
          user: {
            user_id,
            name: original_name,
          },
        },
      });

      return true;
    }
  }

  deserialize({
    type,
    text,
    key,
    entity,
    props,
  }: DeserializePayloadHandlerOptions<Omit<MentionMessageProps, 'user'>>) {
    if (type === MentionElementType) {
      return {
        children: entity.user ? (
          <MentionMessage key={key} user={entity.user} {...props}>
            {text}
          </MentionMessage>
        ) : (
          text
        ),
      };
    }
  }

  deserializeValue({ type, text, entity: { user } }: DeserializePayloadValueHandlerOptions) {
    if (type === MentionElementType) {
      if (user.user_id === '*') {
        user.name = 'All';
      } else {
        user.original_name = user.name;
        const groups = /\((.*)\)/.exec(text);
        user.username = groups?.[1] || '';
      }

      return {
        descendant: jsx('element', {
          type: MentionElementType,
          user,
        }),
      };
    }
  }
}
